import {
  HeaderComponent,
  FooterComponent,
} from "../../file-management/popup/file-management-popup";
import { NormalText } from "../../common/components/title-container/LText";
import { btnResponsive } from "../../common/utils/helper";
import { VIEW_COURSE_CONSTANTS } from "../utils/constants";

interface WarningPopupProps {
  title: string;
  description: string;
  btnText: string;
  btnText1: string;
  onCancel: () => void;
  onTrigger: () => void;
  disabled?: boolean;
}

const WarningPopup = ({
  title,
  description,
  btnText,
  btnText1,
  onCancel,
  onTrigger,
  disabled,
}: WarningPopupProps) => {
  return (
    <div className="flexContainer flexDirection-column h-[310px] w-[400px] xl-low:!h-[310px] xl-mid:!h-[360px] xl-high:!h-[445px] xl-high:!w-[600px]">
      <HeaderComponent title={title} onCancel={onCancel} />
      <div className="mt-2 pt-5 pr-10">
        <NormalText
          title={description}
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] font-medium text-[#E0E0E0]`}
        />
        <NormalText title={VIEW_COURSE_CONSTANTS.DESCRIPTION}  className={`mt-2 mb-1 text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] font-medium text-[#E0E0E0]`}/>
        <NormalText
          title={VIEW_COURSE_CONSTANTS.DESCRIPTION_1}
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] font-medium text-[#E0E0E0]`}
        />
        <NormalText
          title={VIEW_COURSE_CONSTANTS.DESCRIPTION_2}
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] font-medium text-[#E0E0E0]`}
        />
      </div>
      <div className="flexContainer justify-end items-end mt-4 height-100">
        <FooterComponent
          btnText1={btnText1}
          btnText={btnText}
          onCancel={onCancel}
          onTrigger={onTrigger}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default WarningPopup;
